// Speed and/or cadence sensor (CSC service): cadence for everyone, wheel speed for the virtual power
// of a classic trainer.
import { t } from '../i18n/index.js';
import { BleDevice, valueOf, type GattServer, type StatusFn } from './ble.js';
import { UUID, SpeedCadenceParser, type Reading } from './gatt.js';

export class SpeedCadence extends BleDevice {
  private parser: SpeedCadenceParser;
  constructor(private readonly onData: (d: Reading) => void, onStatus: StatusFn, wheelMm: number) { super(onStatus); this.parser = new SpeedCadenceParser(wheelMm); }
  set wheelMm(mm: number) { this.parser.wheelMm = mm; }
  protected fallbackName() { return t.devices.speedCadence; }
  protected filters() { return { filters: [{ services: [UUID.csc] }] }; }
  protected detach() { this.parser.reset(); }
  protected async attach(srv: GattServer) {
    const m = await (await srv.getPrimaryService(UUID.csc)).getCharacteristic(UUID.cscMeasurement);
    m.addEventListener('characteristicvaluechanged', e => this.onData(this.parser.parse(valueOf(e), performance.now())));
    await m.startNotifications();
  }
}
